import { GroupedLocationList } from "./GroupedLocationList";

export default GroupedLocationList;
